import React from "react";
import { fileDisplayLabel } from "../utils/fileMetaDisplay";

function viewerHref(file, module) {
  const id = file._id;
  const fmt = (file.format || "").toUpperCase();
  if (fmt === "PDF") {
    return `/pdfjs/web/viewer.html?file=${encodeURIComponent(`/api/file/${module}/${id}`)}`;
  }
  if (["JPG", "JPEG", "PNG", "GIF", "BMP", "WEBP"].includes(fmt)) {
    return `/viewerjs/index.html?file=${encodeURIComponent(`/api/file/${module}/${id}`)}`;
  }
  return null;
}

function proxyDownload(e, file, module) {
  if (module !== "construction") return;
  e.preventDefault();
  fetch(`/api/file/${module}/${file._id}`)
    .then((response) => {
      if (!response.ok) throw new Error("Download failed");
      return response.blob();
    })
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = file.original_name;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    })
    .catch((error) => {
      console.error("[FileListNameCell] Download failed:", error);
      alert(`Failed to download file: ${error.message}`);
    });
}

/**
 * Primary link label = display_name (fallback original_name); secondary line = technical file name.
 */
export default function FileListNameCell({ file, module }) {
  const label = fileDisplayLabel(file);
  const v = viewerHref(file, module);
  const apiUrl = `/api/file/${module}/${file._id}`;

  if (v) {
    return (
      <div className="max-w-md">
        <a
          href={v}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:underline font-medium"
        >
          {label}
        </a>
        <div className="text-[10px] text-gray-500 mt-0.5 break-words">{file.original_name}</div>
      </div>
    );
  }

  return (
    <div className="max-w-md">
      <a
        href={apiUrl}
        download={file.original_name}
        className="text-blue-600 hover:underline font-medium"
        {...(module === "construction"
          ? { onClick: (e) => proxyDownload(e, file, module) }
          : {})}
      >
        {label}
      </a>
      <div className="text-[10px] text-gray-500 mt-0.5 break-words">{file.original_name}</div>
    </div>
  );
}
